export default class Delay {
  public static async after(func: VoidFunction, miliseconds: number) {
    return new Promise<void>((resolve, _reject) => {
      setTimeout(async() => {
        await func()
        resolve()
      }, miliseconds)
    })
  }
}
